import actionTypes from 'constants/actionTypes'
import defaultsDeep from 'lodash/defaultsDeep'

interface LoginState {
  isFetching: boolean
  returnUrl: string
}

interface LoginAction {
  type?: string
  payload?: {
    returnUrl?: string
  }
}

const initialState: LoginState = {
  isFetching: false,
  returnUrl: '',
}

export default (state: LoginState = initialState, action: LoginAction): LoginState => {
  if (action.type === actionTypes.AUTH.LOGIN.REQUEST) {
    return defaultsDeep(
      {
        isFetching: true
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.LOGIN.RECEIVE) {
    return defaultsDeep(
      {
        isFetching: false
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.LOGIN.FAIL) {
    return defaultsDeep(
      {
        isFetching: false
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.MUST_LOGIN) {
    const ret = defaultsDeep(
      {
        returnUrl: action.payload?.returnUrl
      },
      state
    )
    return ret
  }
  return state
}
